
import { StatCard, StatSection } from '@/components/Metrics'
import { defineComponent } from 'vue'

import RepoDetailMixin from '~/mixins/repoDetailMixin'
import RoleAccessMixin from '~/mixins/roleAccessMixin'
import WidgetMixin from '~/mixins/widgetMixin'

import { RepoPerms } from '~/types/permTypes'

import { WIDGET_ICON_MAP } from '~/utils/repository'
import { formatIntl, shortenLargeNumber, toSentenceCase } from '~/utils/string'

export interface Widget {
  title: string
  value_display: number
  link: string
  description: string
  hint?: string
  has_trend_value: boolean
  trend_direction: string | null
  trend_value: string
  trend_display: string
  trend_positive: boolean
}

export default defineComponent({
  name: 'IssueOverviewCards',
  components: {
    StatSection,
    StatCard
  },
  mixins: [RepoDetailMixin, RoleAccessMixin, WidgetMixin],
  data() {
    return {
      loading: false,
      showCustomizeModal: false,
      timerId: null as ReturnType<typeof setTimeout> | null
    }
  },
  async fetch(): Promise<void> {
    await this.fetchWidgets(this.baseRouteParams)

    this.loading = false
  },
  created() {
    if (process.client) {
      this.timerId = setTimeout(() => {
        if (this.$fetchState.pending) {
          this.loading = true
        }
      }, 300)
    }
  },
  mounted() {
    this.$socket.$on('repo-analysis-updated', this.refetchData)
  },
  beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId)
      this.timerId = null
    }
    this.$socket.$off('repo-analysis-updated', this.refetchData)
  },
  computed: {
    WIDGET_ICON_MAP() {
      return WIDGET_ICON_MAP
    },
    WIDGETS_COUNT() {
      return 6
    },
    issueWidgets(): Record<string, Widget> {
      return this.repository.widgetsDisplay as Record<string, Widget>
    },
    canCustomizeWidgets(): boolean {
      return this.$gateKeeper.repo(RepoPerms.CUSTOMIZE_OVERVIEW_WIDGETS, this.repoPerms.permission)
    }
  },
  methods: {
    shortenLargeNumber,
    formatIntl,
    toSentenceCase,
    isTrendPositive(widget: Widget): boolean {
      if (!widget.trend_value) {
        return true
      }

      if (widget.trend_direction && widget.trend_value) {
        return (
          (widget.trend_direction === 'down' && !widget.trend_positive) ||
          (widget.trend_direction === 'up' && widget.trend_positive)
        )
      } else {
        return false
      }
    },
    refetchData(): void {
      this.fetchWidgets({
        ...this.baseRouteParams,
        refetch: true
      })
    },
    async closeAndRefetchData(): Promise<void> {
      this.showCustomizeModal = false
      await this.refetchData()
    }
  }
})
